import { EventBus } from '../utils/EventBus';
import { GameEvents, RankTier } from '../core/types';
import { ECONOMY } from '../utils/Constants';
import { SaveSystem } from './SaveSystem';

export class ProgressionSystem {
    private static instance: ProgressionSystem;
    private level: number = 1;
    private xp: number = 0;

    private constructor() {
        this.load();
    }

    static getInstance(): ProgressionSystem {
        if (!ProgressionSystem.instance) {
            ProgressionSystem.instance = new ProgressionSystem();
        }
        return ProgressionSystem.instance;
    }

    addXP(amount: number) {
        this.xp += amount;
        this.checkLevelUp();
        this.save();
        EventBus.emit(GameEvents.XPGained, this.xp);
    }

    getLevel(): number {
        return this.level;
    }

    getXP(): number {
        return this.xp;
    }

    getXPForNextLevel(): number {
        return Math.floor(ECONOMY.LEVEL_XP_BASE * Math.pow(ECONOMY.LEVEL_XP_MULTIPLIER, this.level - 1));
    }

    getXPProgress(): number {
        const nextLevelXP = this.getXPForNextLevel();
        return Math.min(this.xp / nextLevelXP, 1);
    }

    getRank(): RankTier {
        if (this.level >= 50) return RankTier.Legend;
        if (this.level >= 30) return RankTier.Diamond;
        if (this.level >= 20) return RankTier.Gold;
        if (this.level >= 10) return RankTier.Silver;
        return RankTier.Bronze;
    }

    checkLevelUp() {
        const requiredXP = this.getXPForNextLevel();
        if (this.xp >= requiredXP) {
            this.xp -= requiredXP;
            this.level += 1;
            EventBus.emit(GameEvents.LevelUp, this.level);
            this.checkLevelUp(); // Recursively check if enough XP for multiple levels
        }
    }

    private load() {
        const profile = SaveSystem.getInstance().load();
        this.level = profile.level;
        this.xp = profile.xp;
    }

    private save() {
        const profile = SaveSystem.getInstance().load();
        profile.level = this.level;
        profile.xp = this.xp;
        profile.rank = this.getRank();
        SaveSystem.getInstance().save(profile);
    }
}
